import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logo-tn',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo-tn.component.html',
  styleUrls: ['./logo-tn.component.scss']
})
export class LogoTnComponent {

}
